import axios from 'axios';
import { parse as qsparse } from 'qs';
import '../application/javascripts/misc/axios-config';
import SearchMap from '@/components/search_map.js.erb';
import 'jquery-ui/ui/widgets/slider';

export default class TherapistSearchResults {
  constructor() {
    this.initPriceSlider();
    this.initMoreFilters();
    this.initTherapistIdentitiesFilters();
    this.initDropdowns();
    this.filterCheckboxes();
    this.preventDropdownMenuCloseOnClick();
    this.submitFromFilters();
    this.headerSearchForm();
    this.clearCheckboxes();
    this.mobileDropdownFixes();
    this.initAvailabilityDatesFilter();
    this.initializeSearchMap();
  }

  initPriceSlider() {
    let priceSlider = $('.price-slider');
    let priceSliderDataset = document.querySelector('.price-slider').dataset;
    let priceMinHiddenField = document.querySelector('.price-slider input#search_price_min');
    let priceMaxHiddenField = document.querySelector('.price-slider input#search_price_max');
    let resetSliderButton = document.querySelector('.more-filters a.clear-filter');
    let selectedPricesSpan = document.querySelector('.price-section .selected-prices');
    let defaultValues = [];
    let self = this;

    defaultValues[0] = parseInt(priceMinHiddenField.value) || parseInt(priceSliderDataset.min);
    defaultValues[1] = parseInt(priceMaxHiddenField.value) || parseInt(priceSliderDataset.max);

    priceSlider.slider({
      range: true,
      min: parseInt(priceSliderDataset.min),
      max: parseInt(priceSliderDataset.max),
      values: defaultValues,
      slide: function (_, ui) {
        priceMinHiddenField.value = ui.values[0];
        priceMaxHiddenField.value = ui.values[1];
        priceMinHiddenField.disabled = false;
        priceMaxHiddenField.disabled = false;

        let maxValue = '';

        if (ui.values[1] == 500) {
          maxValue = `$${ui.values[1]}+`;
        } else {
          maxValue = `$${ui.values[1]}`;
        }

        selectedPricesSpan.textContent = `$${ui.values[0]} - ${maxValue} out of pocket fee`;
      }
    });

    resetSliderButton.addEventListener('click', function (evt) {
      priceSlider.slider('values', [parseInt(priceSliderDataset.min), parseInt(priceSliderDataset.max)]);
      selectedPricesSpan.textContent = `$${parseInt(priceSliderDataset.min)} - $${parseInt(priceSliderDataset.max)}`;
      priceMinHiddenField.value = priceSliderDataset.min;
      priceMaxHiddenField.value = priceSliderDataset.max;
      priceMinHiddenField.disabled = true;
      priceMaxHiddenField.disabled = true;

      let value = evt.target.getAttribute('data-value');
      if (value != null) {
        self.uncheckCheckboxes(value);
        self.encodeAndPerformSearch();
      }
    });
  }

  initDropdowns() {
    let dropdownBtns = document.querySelectorAll('.dropdowns .btn-filter-dropdown');
    let viewportWidth = document.documentElement.clientWidth;

    for (let dropdownBtn of dropdownBtns) {
      let targetDropdown = document.querySelector(`.filters .dropdown-content${dropdownBtn.dataset.target}`);

      dropdownBtn.addEventListener('click', () => {
        if (targetDropdown.classList.contains('is-showing')) {
          dropdownBtn.setAttribute('aria-expanded', 'false');
          targetDropdown.classList.remove('is-showing');
        } else {
          dropdownBtn.setAttribute('aria-expanded', 'true');
          targetDropdown.classList.add('is-showing');

          if (viewportWidth >= 1200) {
            targetDropdown.style.left = `${dropdownBtn.offsetLeft}px`;
          } else {
            targetDropdown.style.left = `${(viewportWidth - targetDropdown.clientWidth) / 2 - 5}px`;
          }
        }
      });

      document.addEventListener('click', (event) => {
        if (
          event.target == dropdownBtn ||
          dropdownBtn.contains(event.target) ||
          targetDropdown.contains(event.target)
        ) {
          return null;
        }

        dropdownBtn.classList.remove('active');
        targetDropdown.classList.remove('is-showing');
      });
    }
  }

  initMoreFilters() {
    let moreFiltersBtn = document.querySelector('.filters .btn-more-filters');
    let moreFiltersContainer = document.querySelector('.filters .more-filters');

    moreFiltersBtn.addEventListener('click', function () {
      if (moreFiltersContainer.classList.contains('is-showing')) {
        moreFiltersContainer.classList.remove('is-showing');
      } else {
        moreFiltersContainer.classList.add('is-showing');
      }
    });

    document.addEventListener('click', function (event) {
      if (
        event.target == moreFiltersBtn ||
        moreFiltersBtn.contains(event.target) ||
        moreFiltersContainer.contains(event.target)
      ) {
        return null;
      }

      moreFiltersBtn.classList.remove('active');
      moreFiltersContainer.classList.remove('is-showing');
    });
  }

  initTherapistIdentitiesFilters() {
    let therapistIdentitiesBtn = document.querySelector('.filters .btn-therapist-identities');
    let therapistIdentitiesFiltersContainer = document.querySelector('.filters .therapist-identities-filters');

    therapistIdentitiesBtn.addEventListener('click', function () {
      if (therapistIdentitiesFiltersContainer.classList.contains('is-showing')) {
        therapistIdentitiesFiltersContainer.classList.remove('is-showing');
      } else {
        therapistIdentitiesFiltersContainer.classList.add('is-showing');
      }
    });

    document.addEventListener('click', function (event) {
      if (
        event.target == therapistIdentitiesBtn ||
        therapistIdentitiesBtn.contains(event.target) ||
        therapistIdentitiesFiltersContainer.contains(event.target)
      ) {
        return null;
      }

      therapistIdentitiesBtn.classList.remove('active');
      therapistIdentitiesFiltersContainer.classList.remove('is-showing');
    });
  }

  initAvailabilityDatesFilter() {
    let availabilityDateCheckboxes = document.querySelectorAll('.availability-date-item input[type="checkbox"]');

    for (let chkbx of availabilityDateCheckboxes) {
      chkbx.addEventListener('change', function (e) {
        let day = e.target.value;
        let availabilityTimeCheckboxes = document.querySelectorAll(`.show-when-${day}`);

        if (e.target.checked) {
          for (let timeChkbx of availabilityTimeCheckboxes) {
            timeChkbx.classList.remove('hide-availability-time');
          }
        } else {
          for (let timeChkbx of availabilityTimeCheckboxes) {
            timeChkbx.classList.add('hide-availability-time');
            timeChkbx.querySelector('input[type="checkbox"]').checked = false;
          }
        }
      });
    }
  }

  // search checkboxes list
  filterCheckboxes() {
    document
      .querySelectorAll('[data-js-filter-checkboxes-input]')
      .forEach((input) => this.addOnChangeEventListener(input));
  }

  addOnChangeEventListener(element) {
    element.addEventListener('keyup', (e) => {
      const filterText = e.target.value;
      const keywords = filterText.trim().split(' ').filter(Boolean);

      e.target
        .closest('[data-js-filter-checkboxes-cont]')
        .querySelectorAll('[data-js-filter-checkbox-row]')
        .forEach((row) => {
          const input = row.querySelector('.form-check-input');
          const searchValue = input.dataset.search || input.value;
          const value = input.value;
          row.hidden = !keywords.every(
            (word) => value.match(RegExp(word, 'i')) || searchValue.match(RegExp(word, 'i'))
          );
        });

      const matches = e.target.closest('[data-js-filter-checkboxes-cont]').querySelectorAll('[data-js-filter-checkbox-row]:not([hidden])').length;
      e.target.closest('[data-js-filter-checkboxes-cont]').querySelector('.match-count .count').textContent = matches;

      if (
        e.target.closest('[data-js-filter-checkboxes-cont]').querySelector('.scrollable-container').offsetHeight < 350
      ) {
        e.target
          .closest('[data-js-filter-checkboxes-cont]')
          .querySelector('.scrollable-container')
          .classList.add('hide-gradient');
      } else {
        e.target
          .closest('[data-js-filter-checkboxes-cont]')
          .querySelector('.scrollable-container')
          .classList.remove('hide-gradient');
      }
    });
  }

  encodeAndPerformSearch() {
    const headerForm = document.querySelector('form[data-js-search-form]');
    const fakeForm = document.createElement('form');
    const activeCheckboxes = [...document.querySelectorAll('input:checked')].filter(
      (el) => !el.hasAttribute('data-js-search-input-include')
    );
    const includedInputs = document.querySelectorAll('[data-js-search-input-include]');
    const rangeInputs = document.querySelectorAll('.price-section input');

    // append price range inputs
    rangeInputs.forEach((rangeInput) => {
      let clone = rangeInput.cloneNode();
      clone.hidden = true;
      fakeForm.appendChild(clone);
    });

    activeCheckboxes.forEach((chbx) => {
      const inputCloned = chbx.cloneNode();
      inputCloned.hidden = true;
      fakeForm.appendChild(inputCloned);
    });

    includedInputs.forEach((el) => {
      const clone = el.cloneNode();
      clone.type = 'hidden';
      clone.value = Boolean(el.checked);
      fakeForm.appendChild(clone);
    });

    const searchobject = new URLSearchParams(new FormData(fakeForm)).toString();

    (async () => {
      const { data } = await axios.post('/tssapi/v0.1/search/process', {
        data: JSON.stringify(qsparse(searchobject))
      });

      const inputSearchdata = document.querySelector('input[name=sdata]') || document.createElement('input');
      inputSearchdata.name = 'sdata';
      inputSearchdata.type = 'hidden';
      inputSearchdata.value = data.sdata;
      headerForm.appendChild(inputSearchdata);
      headerForm.submit();
    })();
  }

  // includes filter inputs when submiting search form on header
  headerSearchForm() {
    let headerForm = document.querySelector('form');
    headerForm.addEventListener('submit', (e, context = this) => {
      e.preventDefault();
      context.encodeAndPerformSearch();
    });
  }

  clearCheckboxes() {
    let clearAnchors = document.querySelectorAll('a.clear-filter');
    clearAnchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        let value = e.target.getAttribute('data-value');
        if (value) {
          this.uncheckCheckboxes(value);
          this.encodeAndPerformSearch();
        }
      });
    });
  }

  uncheckCheckboxes(name) {
    let checkboxes;

    if (name === 'more-filters') {
      checkboxes = document.querySelectorAll('.more-filters input:checked');
    } else if (name === 'therapist-identities-filters') {
      checkboxes = document.querySelectorAll('.therapist-identities-filters input:checked');
    } else {
      checkboxes = document.querySelectorAll(`input[name='search[${name}][]'], input[name='search[${name}]']`);
    }

    checkboxes.forEach((checkbox) => (checkbox.checked = false));
  }

  preventDropdownMenuCloseOnClick() {
    let dropdownMenus = document.querySelectorAll('.dropdown .dropdown-menu');
    dropdownMenus.forEach((dropdownMenu) => {
      if (dropdownMenu.classList.contains('header-dropdown')) {
        return;
      }

      dropdownMenu.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
  }

  submitFromFilters() {
    let submitLinks = document.querySelectorAll('a.apply-filter');
    submitLinks.forEach((link) =>
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.encodeAndPerformSearch();
      })
    );
  }

  mobileDropdownFixes() {
    $(document).on('shown.bs.dropdown', function (e) {
      if (!e.target.classList.contains('nav-item')) {
        let dropdown = $(e.target).find('.dropdown-menu');
        let viewportWidth = document.documentElement.clientWidth;

        if (viewportWidth <= 768) {
          let leftPosition = (viewportWidth - dropdown.width()) / 2;
          dropdown.appendTo('body').css({ top: 113, left: leftPosition });
        } else {
          let searchResultsDiv = document.querySelector('.search-results');
          dropdown.appendTo('body').css({
            top: 113,
            left: e.target.offsetLeft + searchResultsDiv.offsetLeft
          });
        }

        $(this).on('hidden.bs.dropdown', function () {
          dropdown.appendTo(e.target);
        });
      }
    });
  }

  initializeSearchMap() {
    let mapContainer = document.getElementById('results-map-container');

    if (mapContainer != undefined) {
      new SearchMap(mapContainer);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TherapistSearchResults();
});
